<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/Rebate/getData"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="title">
          <Input type="text" v-model="searchData.title" placeholder="标题" class="lx-search-item"></Input>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="showEditDrawer(0)">添加</Button>
        </FormItem>
      </template>

    </pageTable>

    <edit-form v-if="showEdit"
               :show-edit="showEdit"
               :id="editId"
               ref="editModel"
               @cancel-edit="closeEditDrawer"
               @edit-success="editSuccess"
    >
    </edit-form>


    <!-- <Modal
            v-model="showAddAgentUser"
            title="添加推广站点"
            :loading="loading"
            @on-ok="doAddUser">
      <input type="text" v-model="stationUserMobile" placeholder="请输入站点用户手机号">
    </Modal> -->

    <!--<Modal
            v-model="editAgentStationInfo.isShow"
            :title="editAgentStationInfo.agent_info.name"
            :loading="editAgentStationInfo.loading"
            fullscreen
            @on-ok="doEditAgentStationInfo">
      <div>

          <Checkbox
                  :indeterminate="editAgentStationInfo.indeterminate"
                  :value="editAgentStationInfo.checkAll"
                  @click.prevent.native="checkAllAgentStation">全选</Checkbox>
          <Divider size="small" class="ivu-m-0" />
          <CheckboxGroup v-model="editAgentStationInfo.checked" @on-change="editAgentStationInfoChange" class="custom-checkbox">
            <Checkbox v-for="(item,key) in editAgentStationInfo.allStations" :label="item.station_id">{{item.gas_name}}</Checkbox>
          </CheckboxGroup>
      </div>
    </Modal>-->

    <Drawer :title="editAgentStationInfo.name"
            :mask-closable="true"
            width="1000"
            v-model="editAgentStationInfo.isShow"
    >
      <editStation :id="editAgentStationInfo.id" v-if="editAgentStationInfo.isShow"></editStation>
    </Drawer>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  import editStation from "./editStation";
  import editForm from "./edit";
  export default {
    name: "lists",
    components:{pageTable,editForm,editStation},
    data() {
      return {
        showEdit:false,
        editId:0,
        searchData: {
          title:'',
        },
        commissionSearchData:{
          agent_user_id:0
        },
        shareSearchData:{
          agent_user_id:0
        },
        stationSearchData:{
          agent_user_id:0
        },
        showAddAgentUser:false,
        addUserAgentID:0,
        stationUserMobile:'',
        loading:false,
        tableColumn: [
          {title: '编号',key: 'id',align:'center'},
          {title: '标题',key: 'title',align:'center'},
          {title: '充值返利金额',key: 'value',align:'center'},
          {title: '返利的金额',key: 'money',align:'center'},
          {title: '创建时间',key: 'create_time',align:'center'},
        
          {title: '操作',align:'center',render:(h,params)=>{
              let content=[];
             /* content.push(h('Button',{
                  props: {type: 'primary', size: 'small',},
                  style: {marginLeft: '5px'},
                  on: {click: () => {this.showSpreadStation(params.row.id)}
                }
              },'推广站点'));*/
              content.push(h('Button',{
                props: {type: 'error', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.del(params.row.id)}
                }
              },'删除'))
              content.push(h('Button',{
                props: {type: 'primary', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.showEditDrawer(params.row.id)}
                }
              },'编辑'))
              return h('div',content)
            }},
        ],
        commissionTableColumn:[
          {title: '站点名称',key: 'gas_name'},
          {title: '站点类型',key: 'station_type_name'},
          {title: '拨打电话',key: 'mobile'},
          {title: '拨打时间',key: 'create_time'},
          {title: '合伙人佣金',key: 'agent_commission'},
        ],
        shareTableColumn:[
          {title: '注册用户',key: 'mobile'},
          {title: '昵称',key: 'nick_name'},
          {title: '注册时间',key: 'create_time'},
          {title: '佣金',key: 'amount'},
        ],
        editAgentStationInfo:{
          isShow:false,
          checkAll:false,
          indeterminate: true,
          name:'',
          id:0,
          agent_info:{name:''},
          checked:[],
          allStations:[],
          allStationID:[],
          loading:false,
        },
        editAgentCompanyInfo:{
          isShow:false,
          agent_info:{},
        }
      }
    },
    methods: {
      showEditDrawer(id){
        this.showEdit = true;
        this.editId = id
      },
      closeEditDrawer(){
        this.showEdit = false
        this.editId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEdit = false
      },
      async del(id){
        let res = await this.$commonFun.postProxy('admin/rebate/del',{id})
        this.$commonFun.dealApiResult(res,()=>{
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg)
        })
      },
      showStationTable(agent_user_id){
        this.stationSearchData.agent_user_id = agent_user_id
      },
      showCommissionTable(agent_user_id){
        this.commissionSearchData.agent_user_id = agent_user_id
      },
      async setPromoteFee(row){
        let res = await this.$commonFun.postProxy('admin/agent/setPromoteFee',{agent_id:row.id,promote_fee:row.agent_promote_fee})
        this.$commonFun.dealApiResult(res)
        this.$set(row,'$isEdit',false)
      },
      async setShareCommission(row){
        let res = await this.$commonFun.postProxy('admin/agent/setShareCommission',{agent_id:row.id,agent_share_commission:row.agent_share_commission})
        this.$commonFun.dealApiResult(res)
        this.$set(row,'$isEditShare',false)
      },
      addUserAgent(agent_user_id){
        if (agent_user_id>0){
          this.showAddAgentUser = true;
          this.addUserAgentID = agent_user_id
        }else{
          this.$commonFun.errorTip('该合伙人尚未注册')
        }
      },
      async doAddUser(){
        this.loading=true
        let res = await this.$commonFun.postProxy('admin/agent/addUserAgent',{agent_user_id:this.addUserAgentID,station_user_mobile:this.stationUserMobile})
        this.loading=false
        this.$commonFun.dealApiResult(res,()=>{
          this.showAddAgentUser = false;
          this.addUserAgentID = 0
          this.stationUserMobile=''
          this.$commonFun.successTip(res.msg)
        })
      },
      async showEditAgentStation(data){
        this.editAgentStationInfo.isShow = true
        this.editAgentStationInfo.name = data.name
        this.editAgentStationInfo.id = data.id
      },
      checkAllAgentStation(){
        this.editAgentStationInfo.checkAll = this.editAgentStationInfo.checked.length !== this.editAgentStationInfo.allStationID.length
        this.editAgentStationInfo.indeterminate = false;
        console.log(this.editAgentStationInfo.checkAll)
        if (this.editAgentStationInfo.checkAll) {
          this.editAgentStationInfo.checked = this.editAgentStationInfo.allStationID;
        } else {
          this.editAgentStationInfo.checked = [];
        }
      },
      editAgentStationInfoChange (data) {
        console.log(data)
        if (data.length === this.editAgentStationInfo.allStations.length) {
          this.editAgentStationInfo.indeterminate = false;
          this.editAgentStationInfo.checkAll = true;
        } else if (data.length > 0) {
          this.editAgentStationInfo.indeterminate = true;
          this.editAgentStationInfo.checkAll = false;
        } else {
          this.editAgentStationInfo.indeterminate = false;
          this.editAgentStationInfo.checkAll = false;
        }
      },
      async doEditAgentStationInfo(){
        let agent_id =  this.editAgentStationInfo.agent_info.id;
        if (!agent_id) return this.$commonFun.errorTip('请选择需要编辑的代理')
        this.editAgentStationInfo.loading=true
        let res = await this.$commonFun.postProxy('admin/agent/editAgentStation',{id:agent_id,checked: this.editAgentStationInfo.checked})
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.editAgentStationInfo.isShow = false
            this.editAgentStationInfo.indeterminate = false;
            this.editAgentStationInfo.checkAll = false;
            this.editAgentStationInfo.loading=false
            this.editAgentStationInfo.checked = [];
            this.editAgentStationInfo.agent_info = {}
            this.$refs.table.changePage(1);
          })

        })
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>
 .custom-checkbox .ivu-checkbox-inner {
   width: 100px; /* 设置你想要的宽度 */
 }
</style>
